// useUserMessages.tsx
import { useState, useEffect } from "react";
import { getDatabase, ref, onValue } from "firebase/database";
import { score, ScoredMsg } from "./sentimentLocal";

/**  
 * Listen to **all** direct-chat threads, filter down  
 * to messages _sent by_ our selectedUserId, score them,  
 * and sort by timestamp.  
 */

// Copy this utility from your DirectChatScreen (or global utils)
function buildConvId(a: string, b: string) {
  return [a, b].sort().join("_");
}

export const useUserMessages = (userId: string | null) => {
  const [msgs, setMsgs] = useState<ScoredMsg[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const db = getDatabase();

  useEffect(() => {
    if (!userId) {
      setMsgs([]);
      setIsLoading(false);
      return;
    }
    setIsLoading(true);
    const r = ref(db, `directChats`);

    const unsub = onValue(r, (snap) => {
      const arr: ScoredMsg[] = [];
      snap.forEach((threadSnap) => {
        const thread = threadSnap.val();
        if (!thread?.messages) return;

        Object.entries(thread.messages).forEach(([msgId, m]: any) => {
          if (m.userId === userId && m.text) {
            // Use the user's name from the message, fallback to "Unknown User"
            const userName = m.userName || m.user?.name || 'Unknown User';
            arr.push(score(m.text, m.createdAt, m.userId, userName));
          }
        });
      });
      
      arr.sort((a, b) => a.createdAt - b.createdAt);
      setMsgs(arr);
      setIsLoading(false);
    });

    return () => unsub();
  }, [db, userId]);

  return { msgs, isLoading };
};
